import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  en: {
    // common
    "home": "Home", "about": "About", "about_us": "About Us", "faq": "FAQ", "contact": "Contact",
    "login": "Login", "logout": "Logout", "dashboard": "Dashboard", "training": "Training",
    "users": "Users", "employees": "Employees", "pages": "Pages", "typing": "Typing", "results": "Results",
    "save": "Save", "cancel": "Cancel", "delete": "Delete", "edit": "Edit", "view": "View", "submit": "Submit",
    "search": "Search", "next": "Next", "prev": "Prev", "close": "Close", "yes": "Yes", "no": "No",
    "loading": "Loading…", "name": "Name", "email": "Email", "password": "Password", "mobile": "Mobile",
    "first_name": "First Name", "last_name": "Last Name", "actions": "Actions",
    "total": "Total", "completed": "Completed", "accuracy": "Accuracy", "wpm": "WPM",
    "mistakes": "Mistakes", "time_taken": "Time Taken", "start_date": "Start Date", "last_date": "Last Date",
    "from_page": "From Page", "to_page": "To Page", "page": "Page", "select_page": "Select Page",
    "add": "Add", "add_user": "Add User", "add_employee": "Add Employee", "add_page": "Add Page",
    "generate": "Generate", "generate_all": "Generate All", "generate_password": "Generate Password",
    "bulk_import": "Bulk Import", "download_template": "Download CSV Template", "upload_csv": "Upload CSV",
    "show_result": "Show Result?", "account_expired": "Account Expired", "start_typing": "Start Typing",
    "check_result": "Check Result", "submitted": "Submitted", "field": "Field", "original": "Original",
    "typed": "Typed", "diff": "Diff", "reference": "Reference", "type_here": "Type Here",
    "welcome": "Welcome", "language": "Language", "english": "English", "hindi": "हिंदी",
    "saved_draft": "Draft auto-saved", "back": "Back",
    // landing
    "hero_trust": "Trusted by 10,000+ remote operators",
    "hero_title_1": "Welcome to", "hero_title_2": "Work smart. Grow faster.",
    "hero_sub": "Experience freedom, flexibility, and purpose in everything you do. A platform built for digital operators, data professionals, and remote-first teams.",
    "learn_more": "Learn More", "active_operators": "Active Operators",
    "typing_pages": "Typing Pages", "avg_accuracy": "Avg. Accuracy", "async_support": "Async Support",
    "why_join": "Why join", "why_title": "Why Choose DataSprint?", "read_faq": "Read FAQ",
    "remote_freedom": "Remote Freedom", "flexible_hours": "Flexible Hours", "smart_collab": "Smart Collaboration",
    "learn_grow": "Learn & Grow", "connected_community": "Connected Community",
    "cta_title": "Ready to start your typing journey?", "cta_sub": "Get assigned, complete pages on your own pace, and receive accuracy reports — all in one place.",
    "sign_in": "Sign In",
    // login
    "welcome_back": "Welcome back.", "sign_in_sub": "Sign in to your DataSprint account.",
    "signing_in": "Signing in…", "admin_note": "Please login using the credentials provided by DataSprint. Contact support if you face any login issues.",
    // candidate
    "your_assignment": "Here's a snapshot of your assignment.",
    "account_expired_msg": "Your submission deadline has passed. Contact your admin for an extension.",
    "page_locked": "Account expired — you cannot submit further.",
    "select_page_to_start": "Select a page and type the content into the matching field.",
    "submit_success": "Submitted!",
    // admin
    "admin_overview": "Admin Overview", "control_room": "Welcome to the DataSprint control room.",
    "admin_users_title": "Admin Users", "employees_title": "Employees", "pages_title": "Typing Pages",
    "training_videos": "Training Videos",
    "stats_daily": "Submissions — Last 7 Days", "stats_buckets": "Accuracy Distribution",
    // misc
    "max_500": "Maximum 500 pages per assignment.",
    "blank_keep": "(leave blank to keep current)",
    "show_result_to_candidate": "Show result to candidate?",
  },
  hi: {
    "home": "होम", "about": "हमारे बारे में", "about_us": "हमारे बारे में", "faq": "सामान्य प्रश्न", "contact": "संपर्क",
    "login": "लॉगिन", "logout": "लॉगआउट", "dashboard": "डैशबोर्ड", "training": "प्रशिक्षण",
    "users": "यूज़र्स", "employees": "कर्मचारी", "pages": "पेज", "typing": "टाइपिंग", "results": "परिणाम",
    "save": "सहेजें", "cancel": "रद्द करें", "delete": "हटाएँ", "edit": "संपादित करें", "view": "देखें", "submit": "सबमिट",
    "search": "खोजें", "next": "अगला", "prev": "पिछला", "close": "बंद करें", "yes": "हाँ", "no": "नहीं",
    "loading": "लोड हो रहा है…", "name": "नाम", "email": "ईमेल", "password": "पासवर्ड", "mobile": "मोबाइल",
    "first_name": "पहला नाम", "last_name": "उपनाम", "actions": "क्रियाएँ",
    "total": "कुल", "completed": "पूर्ण", "accuracy": "सटीकता", "wpm": "शब्द/मिनट",
    "mistakes": "गलतियाँ", "time_taken": "लगा समय", "start_date": "आरंभ तिथि", "last_date": "अंतिम तिथि",
    "from_page": "पेज से", "to_page": "पेज तक", "page": "पेज", "select_page": "पेज चुनें",
    "add": "जोड़ें", "add_user": "यूज़र जोड़ें", "add_employee": "कर्मचारी जोड़ें", "add_page": "पेज जोड़ें",
    "generate": "जनरेट", "generate_all": "सभी जनरेट करें", "generate_password": "पासवर्ड जनरेट",
    "bulk_import": "बल्क इम्पोर्ट", "download_template": "CSV टेम्पलेट डाउनलोड", "upload_csv": "CSV अपलोड",
    "show_result": "परिणाम दिखाएँ?", "account_expired": "खाता समाप्त", "start_typing": "टाइपिंग शुरू करें",
    "check_result": "परिणाम देखें", "submitted": "सबमिट किया", "field": "फ़ील्ड", "original": "मूल",
    "typed": "टाइप किया", "diff": "अंतर", "reference": "संदर्भ", "type_here": "यहाँ टाइप करें",
    "welcome": "स्वागत है", "language": "भाषा", "english": "English", "hindi": "हिंदी",
    "saved_draft": "ड्राफ़्ट स्वतः सहेजा गया", "back": "वापस",
    "hero_trust": "10,000+ रिमोट ऑपरेटर्स का भरोसा",
    "hero_title_1": "स्वागत है", "hero_title_2": "स्मार्ट काम करें। तेज़ी से बढ़ें।",
    "hero_sub": "हर काम में स्वतंत्रता, लचीलापन और उद्देश्य का अनुभव करें। डिजिटल ऑपरेटर्स, डेटा पेशेवरों और रिमोट-फ़र्स्ट टीमों के लिए बनाया गया प्लेटफ़ॉर्म।",
    "learn_more": "और जानें", "active_operators": "सक्रिय ऑपरेटर्स",
    "typing_pages": "टाइपिंग पेज", "avg_accuracy": "औसत सटीकता", "async_support": "एसिंक सहायता",
    "why_join": "क्यों जुड़ें", "why_title": "DataSprint क्यों चुनें?", "read_faq": "FAQ पढ़ें",
    "remote_freedom": "रिमोट स्वतंत्रता", "flexible_hours": "लचीले घंटे", "smart_collab": "स्मार्ट सहयोग",
    "learn_grow": "सीखें और बढ़ें", "connected_community": "जुड़ा हुआ समुदाय",
    "cta_title": "अपनी टाइपिंग यात्रा शुरू करने के लिए तैयार हैं?", "cta_sub": "असाइनमेंट लें, अपनी गति से पेज पूरे करें, और सटीकता रिपोर्ट प्राप्त करें — सब एक जगह पर।",
    "sign_in": "साइन इन",
    "welcome_back": "वापस स्वागत है।", "sign_in_sub": "अपने DataSprint खाते में साइन इन करें।",
    "signing_in": "साइन इन हो रहा है…", "admin_note": "कृपया DataSprint द्वारा प्रदान की गई क्रेडेंशियल्स से लॉगिन करें। समस्या होने पर सहायता से संपर्क करें।",
    "your_assignment": "यहाँ आपके असाइनमेंट का सारांश है।",
    "account_expired_msg": "आपकी सबमिशन तिथि समाप्त हो चुकी है। एडमिन से संपर्क करें।",
    "page_locked": "खाता समाप्त — आप अब सबमिट नहीं कर सकते।",
    "select_page_to_start": "एक पेज चुनें और सामग्री को मिलते फ़ील्ड में टाइप करें।",
    "submit_success": "सबमिट हो गया!",
    "admin_overview": "एडमिन ओवरव्यू", "control_room": "DataSprint कंट्रोल रूम में आपका स्वागत है।",
    "admin_users_title": "एडमिन यूज़र्स", "employees_title": "कर्मचारी", "pages_title": "टाइपिंग पेज",
    "training_videos": "प्रशिक्षण वीडियो",
    "stats_daily": "सबमिशन्स — पिछले 7 दिन", "stats_buckets": "सटीकता वितरण",
    "max_500": "प्रति असाइनमेंट अधिकतम 500 पेज।",
    "blank_keep": "(खाली छोड़ें = वर्तमान रखें)",
    "show_result_to_candidate": "कैंडिडेट को परिणाम दिखाएँ?",
  }
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("dw_lang") || "en");
  useEffect(() => { localStorage.setItem("dw_lang", lang); }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.en[k] || k;
  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
